var p = Object.defineProperty, a = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var t = (m, e, o) => e in m ? p(m, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : m[e] = o, l = (m, e) => {
  for (var o in e || (e = {}))
    c.call(e, o) && t(m, o, e[o]);
  if (r)
    for (var o of r(e))
      s.call(e, o) && t(m, o, e[o]);
  return m;
}, i = (m, e) => a(m, f(e));
import n, { forwardRef as B } from "react";
import d from "../lib/IconBase.mjs";
import w from "../defs/BellSimple.mjs";
const R = B((m, e) => /* @__PURE__ */ n.createElement(d, i(l({ ref: e }, m), { weights: w })));
R.displayName = "BellSimple";
export {
  R as BellSimple
};
